import React, { createContext, useState, useContext } from 'react';
import { STORAGE_KEYS } from '../constants/storage';
import { v4 as uuidv4 } from 'uuid';

interface SessionContextType {
  sessionId: string | null;
  setSessionId: (id: string) => void;
  clearSession: () => void;
}

const SessionContext = createContext<SessionContextType | undefined>(undefined);

export const SessionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [sessionId, setSessionId] = useState<string>(() => {
    const newSessionId = uuidv4();
    localStorage.removeItem(STORAGE_KEYS.SESSION_ID);
    localStorage.setItem(STORAGE_KEYS.SESSION_ID, newSessionId);
    return newSessionId;
  });

  const clearSession = () => {
    const newSessionId = uuidv4();
    setSessionId(newSessionId);
    localStorage.setItem(STORAGE_KEYS.SESSION_ID, newSessionId);
  };

  return (
    <SessionContext.Provider value={{ sessionId, setSessionId, clearSession }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  const context = useContext(SessionContext);
  if (context === undefined) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
};